import { useMemo, useState } from "react";
import { Button, Flex, Table, Typography } from "antd";
import { PlusSquareTwoTone } from "@ant-design/icons";
import { getBundlesTableColumns } from "./BundlesTableColumns";
import CreateBundleForm from "./CreateBundleForm";
import { useGetAllBundleDealsQuery } from "../../../api/admin/webshop/bundles/BundleDealsApi";
import { BundleItem } from "../../../api/admin/webshop/bundles/BundleItem";

export default function BundleDealsPage() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [formMode, setFormMode] = useState<"create" | "view" | "edit">(
    "create",
  );
  const [selectedBundle, setSelectedBundle] = useState<BundleItem | undefined>(
    undefined,
  );

  const { data: apiData, isFetching, refetch } = useGetAllBundleDealsQuery();

  const transformedData: BundleItem[] = useMemo(() => {
    return apiData?.items ?? [];
  }, [apiData]);

  const handleViewDetails = (record: BundleItem) => {
    setSelectedBundle(record);
    setFormMode("view");
    setShowAddModal(true);
  };

  const handleCreate = () => {
    setSelectedBundle(undefined);
    setFormMode("create");
    setShowAddModal(true);
  };

  return (
    <Flex gap={8} vertical>
      {showAddModal && (
        <CreateBundleForm
          showModal={showAddModal}
          onCancel={() => setShowAddModal(false)}
          onSuccess={() => refetch()}
          mode={formMode}
          initialValues={selectedBundle}
        />
      )}
      <Flex justify="space-between" align="end">
        <Typography.Title level={2}>Bundle Deals</Typography.Title>
        <Button icon={<PlusSquareTwoTone />} onClick={handleCreate}>
          Create Bundle Deal
        </Button>
      </Flex>
      <Table
        rowKey={(record) => record.promoCode}
        dataSource={transformedData}
        loading={isFetching}
        columns={getBundlesTableColumns(handleViewDetails)}
        pagination={{
          pageSize: 15,
          showSizeChanger: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
      />
    </Flex>
  );
}
